export const changingBgImages = [
    "../assets/images/training_students.jpg", 
    "../assets/images/training_students_2.jpg", 
    "../assets/images/training_students_3.webp"
];

export const changingTextColors = ["#FFFFFF", "#5541D7", "#11142D"];

export const changingParagraphTxtColors = ['grey', 'white', 'black'];